import React, {
  useContext
} from 'react';

import PropTypes from 'prop-types';

import {
  SalesContext
} from '../../../Context/SalesContext';

import IncludedServiceComponent from '../../../Components/Common/IncludedServiceComponent/IncludedServiceComponent';

import {
  HorizontalLine,
  Text
} from '../../../StyledComponents';

import GreyPromotionIcon from '../../Common/Svg/GreyPromotionIcon';

import {
  isMobileView
} from '../../../Utility/utility';

import './QuoteItem.css';

const QuoteItemC = (props) => {
  const context = useContext(SalesContext);

  const discountMonthValue = props.contractTerm?.discountTerm?.split(' ');

  function getDiscountString() {
    let discount = parseFloat(context.selectedPackage.productPrice.value) - parseFloat(context.selectedPackage?.discountAmount);
    let price = discount === 0 ? 'FREE' : `Only pay R${ discount } for the first`;

    return (`${ price } ${ context?.selectedPackage?.discountTerm }`);
  }

  let monthlyTotal = 0;
  let onceOffTotal = 0;

  if (context.additionalVas) {
    context.additionalVas.map(item => {
      if (parseInt(item?.contractTerm) == parseInt(context.selectedContractTerm?.duration) || item.category == 'contractCover') {
        monthlyTotal += parseFloat(item?.price?.replace('R', ''));
      } else {
        onceOffTotal += parseFloat(item?.price?.replace('R', ''));
      }
    });
    monthlyTotal += parseFloat(context.selectedPackage?.productPrice.value);
  } else {
    monthlyTotal = context.selectedPackage?.productPrice.value;
  }

  monthlyTotal = parseFloat(monthlyTotal).toFixed(2);
  onceOffTotal = parseFloat(onceOffTotal).toFixed(2);

  return (
    <div className='quote-item-container'>
      {props.contractTerm && props.contractTerm.discountTerm &&
        <div className='plan-details-summary-discount-tag quotation-discount-tag' automationid="SalesLead_Paragraph_PlanDetailsCardHeaderDiscount_0">On promotion</div>
      }
      <div className='quote-item-header quote-item-detail' automationid={'SalesLead_Div_ItemHeader_0'}>
        <p automationid={'SalesLead_P_QuoteItemName_0'}>{props.name}</p>
        <p automationid={'SalesLead_P_QuoteItemMonthlyCost_0'} className='quote-item-header-price'>
          {props.monthlyCost} {context.selectedContractTerm.duration == '12 Months' ? 'x 12' : context.selectedContractTerm.duration == '24 Months' ? 'x 24' : 'PM'}
        </p>
      </div>

      <div className='quote-item-details'>
        <div className='quote-item-detail' automationid={'SalesLead_Div_QuoteItemDetails_0'}>
          <p automationid={'SalesLead_P_QuoteItemDataLabel_0'}>Data: </p>
          <p automationid={'SalesLead_P_QuoteItemDataValue_0'}>{props.data}</p>
        </div>

        <div className='quote-item-detail' automationid={'SalesLead_Div_QuoteItemDetails_1'}>
          <p automationid={'SalesLead_P_QuoteItemDataLabel_1'}>Period: </p>
          <p automationid={'SalesLead_P_QuoteItemDataValue_1'}>{props.period}</p>
        </div>

        {(!!props.installationCost && props.installationCost > 0) &&
          <div className='quote-item-detail' automationid={'SalesLead_Div_QuoteItemDetails_1'}>
            <p automationid={'SalesLead_P_QuoteItemDataLabel_2'}>Once-off cost:</p>
            <p automationid={'SalesLead_P_QuoteItemDataValue_2'}>{props.installationCost}</p>
          </div>
        }
        {props.contractTerm.discountTerm &&

          <p className='generic-discount-container quotation-discount-container' automationid={`SalesLeads_p_packageDiscount${ props.contractTerm.discountAmount }_1`} >
            <GreyPromotionIcon
              marginRight='7px'
            />
            <Text
              lineheight="0"
              fontWeight="400"
              fontSize="14px"
              color="#85858C"
            >
              Promotion:
            </Text>
            {isMobileView() ?

              <Text
                lineheight="0"
                fontWeight="700"
                fontSize="14px"
                color="#9C2AA0"
                paddingLeft="5px"
                automationid={`SalesLeads_p_packageDiscount${ props.contractTerm.discountAmount }_2`}
              >
                {`R${ props.contractTerm.discountAmount } off for ${ discountMonthValue[0] === '1' ? '1 month' : `${ discountMonthValue[0] } months` }`}
              </Text>
              :
              <Text
                lineheight="0"
                fontWeight="700"
                fontSize="14px"
                color="#9C2AA0"
                paddingLeft="5px"
                automationid={`SalesLeads_p_packageDiscount${ props.contractTerm.discountAmount }_2`}
              >
                {getDiscountString()}

              </Text>
            }
          </p>
        }
      </div>
      {
        (context.selectedPackageType == 'Vodacom One Deals' || context.selectedPackageType == 'Premium Fibre Deals') && context.selectedContractTerm?.inclusions?.length > 0 ?
          <div className="quote-item-inclusions">
            <IncludedServiceComponent
              inclusionsList={context.selectedContractTerm?.inclusions}
              bgcolor="#FFFFF"
              isDevice={false}
            />
          </div>
          :
          null
      }
      {
        context.additionalVas ?
          context.additionalVas.map((item, index) => {
            if (item.category == 'superWifi') {
              return (
                <div className="quote-item-additional-vas">
                  {
                    context.selectedPackageType != 'Vodacom One Deals' ?
                      <HorizontalLine />
                      :
                      <br />
                  }
                  <div className="quote-item-tbyb-promotion">Try before you buy</div>
                  <div className='quote-item-header quote-item-detail quote-item-detail-mobile' automationid={'SalesLead_Div_ItemHeader_2'}>
                    <p automationid={'SalesLead_P_QuoteItemName_2'}>{item?.displayName}</p>
                    <p automationid={'SalesLead_P_QuoteItemMonthlyCost_2'} className='quote-item-header-price'>{`${ item?.price } ${ parseInt(item?.contractTerm) ? 'x ' + parseInt(item?.contractTerm) : '' }`}</p>
                  </div>
                  <div className='quote-item-details'>
                    <p automationid={'SalesLead_P_QuoteItemDataLabel_3'}>14-day trial period</p>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="quote-item-additional-vas">
                  {
                    context.selectedPackageType != 'Vodacom One Deals' ?
                      <HorizontalLine />
                      :
                      <br />
                  }
                  <div className='quote-item-header quote-item-detail quote-item-detail-mobile' automationid={'SalesLead_Div_ItemHeader_2'}>
                    <p automationid={'SalesLead_P_QuoteItemName_2'}>{item?.displayName}</p>
                    <p automationid={'SalesLead_P_QuoteItemMonthlyCost_2'} className='quote-item-header-price'>{`${ item?.price } ${ parseInt(item?.contractTerm) ? 'x ' + parseInt(item?.contractTerm) : item.category == 'contractCover' ? ' PM' : '' }`}</p>
                  </div>
                  <div className='quote-item-details'>
                    <p automationid={'SalesLead_P_QuoteItemDataLabel_3'}>{item.category == 'contractCover' ? 'Pays for your contract expenses in the event of death' : ''}</p>
                  </div>
                </div>
              );
            }
          })
          :
          null
      }

      <div className='quote-item-footer'>
        {/* <div className='footer-item' automationid={`SalesLead_Div_FooterItem_1`}>
          <p
            automationid={`SalesLead_P_OnceOfCostLabel_1`}
            className="quote-cost-label"
          >
            Once-off Cost:
          </p>
          <p
            automationid={`SalesLead_P_OnceOfCostValue_1`}
            className="quote-cost-price"
          >
            {props.onceOffCost || 'R 0 X PM'}
          </p>
        </div> */}
        {
          onceOffTotal > 0 ?
            <div className='footer-item' automationid={'SalesLead_Div_FooterItem_2'}>
              <p
                automationid={'SalesLead_P_MonthlyCostLabel_2'}
                className="quote-cost-label"
              >
                Once-off cost:
              </p>
              <p
                automationid={'SalesLead_P_MonthlyCostValue_2'}
                className="quote-cost-price"
              >
                R{onceOffTotal}
              </p>
            </div>
            :
            null
        }
        <div className='footer-item' automationid={'SalesLead_Div_FooterItem_2'}>
          <p
            automationid={'SalesLead_P_MonthlyCostLabel_2'}
            className="quote-cost-label"
          >
            Total:
          </p>
          <p
            automationid={'SalesLead_P_MonthlyCostValue_2'}
            className="quote-cost-price"
          >
            R{monthlyTotal} PM
          </p>
        </div>
      </div>
    </div>
  );
};

QuoteItemC.propTypes = {
  data: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onceOffCost: PropTypes.string,
  monthlyCost: PropTypes.string.isRequired,
  installationCost: PropTypes.string,
  period: PropTypes.string.isRequired,
  contractTerm: PropTypes.string.isRequired
};

export const QuoteItem = QuoteItemC;
